import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import typography from '../../../styling/mixins/typography';
import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';
import colors, { hover } from '../../../styling/colors';

export const linkStyles = ({ hideUnderline, color }) => css`
  ${typography.trackedStyles};
  background-color: inherit;
  border: none;
  ${hideUnderline ? '' : 'border-bottom: 1px solid ' + colors(color) + ';'};
  color: ${colors(color)};
  cursor: pointer;
  display: inline-block;
  padding-bottom: 2px;
  text-decoration: none;
  text-transform: uppercase;

  &:hover {
    border-color: ${hover(color)};
    color: ${hover(color)};
    text-decoration: none;
  }

  @media (${DESKTOP_START_QUERY}) {
    padding-bottom: 4px;
  }
`;

const TrackedLink = styled.button`
  ${linkStyles};
`;

TrackedLink.propTypes = {
  children: PropTypes.any.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

TrackedLink.defaultProps = {
  color: 'lapel',
};

TrackedLink.displayName = 'TrackedLink';

export default TrackedLink;
